var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multiSelectSlider"},[_c('MultiRangeSlider',{attrs:{"min":_vm.min,"max":_vm.max,"step":1,"ruler":false,"label":false,"minValue":_vm.start,"maxValue":_vm.end},on:{"input":_vm.UpdateValues}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }